/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

/* utilities */
import { parseDataToProps } from '../../utilities';

const searchNodes = Array.from(document.querySelectorAll('div[data-education-programs]'));
if (searchNodes.length) {
    import(/* webpackChunkName: "EducationPrograms" */ './components/EducationPrograms').then(({ default: EducationPrograms }) => {
        searchNodes.forEach((node) => createRoot(node).render(<EducationPrograms {...parseDataToProps(node.dataset)}/>));
    });
}
